import _ from 'lodash';
import {
  CONDOLENCES_QUERY_TEMPATE,
  GALLERY_QUERY_TEMPATE,
} from './templates/queryTemplates';
import {CONDOLENCE_MUTATION_TEMPLATE} from './templates/mutationTemplates';
import gatewayFetch from '../../appModules/utilities/gatewayFetch';
import {
  queryRequest,
  queryFailure,
  mutationRequest,
  mutationFailure,
  queryCondolencesSuccess,
  queryGallerySuccess,
  mutateCondolenceSuccess,
  resetMutationStatus,
} from './actions';

/**
 * Fetches additional condolences from graphQL
 * @method queryCondolences
 * @param  {object}   queryParams parameter to add to the query template
 * @return {function} returns the function to make the fetch
 */
export function queryCondolences(queryParams) {
  return dispatch => {
    dispatch(queryRequest());
    if (!_.isEmpty(queryParams)) {
      const query = CONDOLENCES_QUERY_TEMPATE(queryParams);

      return gatewayFetch(query, 'query')
        .then(data => dispatch(queryCondolencesSuccess(data)))
        .catch(reason => dispatch(queryFailure(reason)));
    }

    dispatch(queryFailure('no fetch parameters present'));
  };
}

/**
 * Fetches additional gallery condolences from graphQL
 * @method queryCondolences
 * @param  {object}   queryParams parameter to add to the query template
 * @return {function} returns the function to make the fetch
 */
export function queryGalleryCondolences(queryParams) {
  return dispatch => {
    dispatch(queryRequest());
    if (!_.isEmpty(queryParams)) {
      const query = GALLERY_QUERY_TEMPATE(queryParams);

      return gatewayFetch(query, 'query')
        .then(data => dispatch(queryGallerySuccess(data)))
        .catch(reason => dispatch(queryFailure(reason)));
    }

    dispatch(queryFailure('no fetch parameters present'));
  };
}

/**
 * Posts a condolence through the gateway to the guestbook service
 * @method mutateCondolence
 * @param  {object}   mutationParams parameters to add to the query template
 * @return {function} returns the function to make the post
 */
export function mutateCondolence(mutationParams) {
  return dispatch => {
    dispatch(mutationRequest());

    if (!_.isEmpty(mutationParams)) {
      const query = CONDOLENCE_MUTATION_TEMPLATE(mutationParams);

      return gatewayFetch(query, 'mutation')
        .then(data => dispatch(mutateCondolenceSuccess(data)))
        .catch(reason => dispatch(mutationFailure(reason)));
    }

    dispatch(mutationFailure('no post parameters present'));
  };
}

/**
 * Resets the condolence mutation status after a mutation attempt
 * @method resetCondlenceMutationStatus
 * @param  {number}   mutationStatus - an entry id if successful, a `0` if failed
 * @return {function} returns the function to reset the mutation status
 */
export function resetCondlenceMutationStatus(mutationStatus) {
  return dispatch => {
    if (_.isNumber(mutationStatus)) {
      dispatch(resetMutationStatus());
    }
  };
}



// WEBPACK FOOTER //
// ./src/reactModules/redux/condolenceHelper.js